import React from 'react';
import '../AchivementPage/AchivementPage.css'
function AchivementPage() {
  return <div>
      
  </div>;
}

export default AchivementPage;
